import { useEffect, useState } from "react";
import { FirestoreService } from "../../../../../../shared/api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../../../../../shared/api/firebase/references";

const useFetchPayerSubtypes = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const fetchPayerSubtypes = async () => {
      const payerSubtypes = await FirestoreService.getDocument(
        FirestoreDocumentReference.narPayersSubTypes(),
      );
      setData(payerSubtypes as any[]);
      setLoading(false);
    };

    fetchPayerSubtypes();
  }, []);

  return { data, loading };
};

export default useFetchPayerSubtypes;
